import trackForInstall from '@apps-once/facades/track-for-install';
import { useOnceStore } from '@apps-once/store';
import { useSubscriptionStore } from '@apps-once/store/subscription';

export function trackForInstallOnceStore(event, data) {
  const onceStore = useOnceStore();
  const subscriptionStore = useSubscriptionStore();

  trackForInstall(event, data, {
    ID: onceStore.id,
    installationId: onceStore.id,
    hostname: onceStore.hostname,
    edition: {
      ID: onceStore.plan,
      edition: subscriptionStore.getPlanNameTracking(onceStore.plan),
    },
    country: onceStore.country,
  });
}
